import { format } from 'date-fns';

export const getInvestorExitStatementPdfFilename = (
  exitStatement: {
    company: {
      tradingName: string;
    };
    amendment?: {
      date?: string;
    };
    exit: {
      date: string;
    };
  },
  fullName?: string,
  isLoss?: boolean,
) => {
  const amendmentDate = exitStatement.amendment?.date?.trim();
  const dateString =
    amendmentDate && amendmentDate.length > 0
      ? amendmentDate
      : exitStatement.exit.date;
  const realisationDate = format(new Date(dateString), 'dd-MM-yyyy');
  const statementLabel = isLoss ? 'Loss Statement' : 'Exit Statement';

  return `${fullName ?? ''} - ${statementLabel} - ${
    exitStatement.company.tradingName
  } - ${realisationDate}.pdf`;
};
